import { useContext, useEffect, useRef, useState } from "react";
import { LuContact, LuSquareFunction } from "react-icons/lu";
import { SlCallIn, SlCallOut } from "react-icons/sl";
import {
  Box,
  Button,
  Card,
  Checkbox,
  CheckboxGroup,
  CloseButton,
  Flex,
  Grid,
  GridItem,
  Heading,
  Skeleton,
  Spinner,
  Stack,
  Tag,
  Text,
  theme,
  Tooltip,
  useColorModeValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";

import dateFormat from "../../utils/DateFormat/dateFormat";
import { fetchController } from "../../utils/FetchController/fetchController";

import { FaFileDownload, FaMicrophone } from "react-icons/fa";
import { FiMessageSquare, FiSend } from "react-icons/fi";
import { MdOutlinePauseCircle, MdOutlinePlayCircle, MdOutlineCancel } from "react-icons/md";
import { PiRobotLight } from "react-icons/pi";
import { TbDeviceDesktop } from "react-icons/tb";
import { Input } from "@chakra-ui/react";
import Message from "./Message";
import axios from "axios";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomDateRangePicker from "../../utils/CustomDateRange/CustomDateRangePicker";
import CustomSelect from "../../utils/CustomSelect/CustomSelect";
import { exportData } from "../../utils/utilFunc";
import { getHostDomain } from "../../utils/utils";
import ConversationLogsPage from "../Logs/ConversationLogsPage";
import ConfirmationModal from "../Modals/Confirmation";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import Summary from "./Summary";
import { providers } from "../Widgets/utils.js";

const ConversationsUtility = ({ tab, screenType, isActive }) => {
  const baseUrl = getHostDomain();
  const skeletonMap = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

  const [searchParams, setSearchParams] = useSearchParams();

  const { onClose: onMetaDataClose } = useDisclosure();
  const {
    isOpen: isToolFunctionLogOpen,
    onOpen: onToolFunctionLogOpen,
    onClose: onToolFunctionLogClose,
  } = useDisclosure();
  const [chatClose, setChatClose] = useState(false);

  let widget = searchParams?.get("widget");
  let intent = searchParams?.get("intent");
  let urldateRange = searchParams?.get("dateRange");
  let convId = searchParams?.get("convId");
  let voiceOnly = searchParams?.get("voiceOnly");
  const [conversationLoading, setconversationLoading] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);
  const [converSationdata, setconverSationdata] = useState([]);
  const [hasMore, sethasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [messages, setMessages] = useState([]);
  const [selectedChat, setSelectedChat] = useState(convId ? convId : "");
  const [conversationChatData, setConversationChatData] = useState(null);

  const [deleteChatId, setDeleteChatId] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(false);

  // AI Pause / Take Control
  const [aiPaused, setAiPaused] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [agentMessage, setAgentMessage] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);

  // Sync aiPaused + isClosed when selected conversation changes
  useEffect(() => {
    if (conversationChatData?.attributes) {
      try {
        const attrs = typeof conversationChatData.attributes === "string"
          ? JSON.parse(conversationChatData.attributes)
          : conversationChatData.attributes;
        setAiPaused(!!attrs?.ai_paused);
        setIsClosed(!!attrs?.is_closed);
      } catch {
        setAiPaused(false);
        setIsClosed(false);
      }
    } else {
      setAiPaused(false);
      setIsClosed(false);
    }
  }, [conversationChatData]);

  const toggleAiPause = async () => {
    if (!selectedChat) return;
    const newPaused = !aiPaused;
    try {
      await fetchController(
        baseUrl + `/api/v1/conversation/${selectedChat}/pause`,
        "PATCH",
        { ai_paused: newPaused }
      );
      setAiPaused(newPaused);
      toast.success(newPaused ? "AI paused — you're in control." : "AI resumed.");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Failed to update conversation.");
    }
  };

  const closeConversation = async () => {
    if (!selectedChat) return;
    try {
      await fetchController(
        baseUrl + `/api/v1/conversation/${selectedChat}/close`,
        "POST"
      );
      toast.success("Conversation closed. Next message will start a new one.");
      setAiPaused(false);
      setAgentMessage("");
      refreshConversation();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Failed to close conversation.");
    }
  };

  const sendAgentMessage = async () => {
    if (!agentMessage.trim() || !conversationChatData) return;
    setSendingMessage(true);
    try {
      await fetchController(
        baseUrl + `/api/v1/messaging/${conversationChatData.widget_id}`,
        "POST",
        {
          contact_id: conversationChatData.contact_id,
          conversation_id: conversationChatData.id,
          message: agentMessage.trim(),
          start_new_conversation: false,
        }
      );
      setAgentMessage("");
      // Refresh messages
      handleConversationapiCall(selectedChat, conversationChatData);
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Failed to send message.");
    } finally {
      setSendingMessage(false);
    }
  };

  const [deleteCheckedItems, setDeleteCheckedItems] = useState([]);
  const [deleteAllChecked, setDeleteAllChecked] = useState(false);
  const [isDeleteIndeterminate, setIsDeleteIndeterminate] = useState(false);
  const [deleteCheckedConversationLoader, setDeleteCheckedConversationLoader] =
    useState(false);

  useEffect(() => {
    let allChecked = false;
    if (converSationdata.length && deleteCheckedItems.length) {
      allChecked =
        converSationdata.length === deleteCheckedItems.length ? true : false;
      setDeleteAllChecked(allChecked);
    }
    const isIndeterminate = !allChecked && deleteCheckedItems.length;
    setIsDeleteIndeterminate(isIndeterminate);
  }, [deleteCheckedItems, converSationdata]);

  const [selectionAssistant, setselectionAssistant] = useState(
    widget ? JSON.parse(widget) : ""
  );
  const [assistantOption, setassistantOption] = useState([]);
  const [selectionIntent, setselectionIntent] = useState(
    intent ? JSON.parse(intent) : ""
  );
  const [audioChecked, setaudioChecked] = useState(
    voiceOnly
      ? searchParams.get("voiceOnly") === "true"
        ? true
        : false
      : false
  );
  const [intentOption, setintentOption] = useState([]);

  const [dateRange, setDateRange] = useState(
    urldateRange
      ? {
          startDate: new Date(decodeURIComponent(urldateRange).split(`,`)[0]),
          endDate: new Date(decodeURIComponent(urldateRange).split(`,`)[1]),
        }
      : {
          startDate: moment().subtract(7, "d").toDate(),
          endDate: moment().toDate(),
        }
  );

  const handleDateChange = (range) => {
    setconverSationdata([]);
    setMessages([]);
    sethasMore(true);
    setPage(1);
    setDateRange(
      range
        ? {
            startDate: range.startDate,
            endDate: range.endDate,
          }
        : dateRange
    );

    setSearchParams({
      widget: selectionAssistant ? JSON.stringify(selectionAssistant) : "",
      intent: selectionIntent ? JSON.stringify(selectionIntent) : "",
      voiceOnly: audioChecked,
      dateRange: encodeURIComponent([range.startDate, range.endDate]),
    });
  };
  const elementRef = useRef(null);
  const endpointassistant = "/api/v1/assistant/list";
  const endpointIntent = "/api/v1/intent/list";

  const urlHitAssistant = baseUrl + endpointassistant;
  const urlHitIntent = baseUrl + endpointIntent;

  const handleConversation = async (data, chatData) => {
    setSelectedChat("");
    setMessages([]);
    onMetaDataClose();
    onToolFunctionLogClose();
    setChatClose(false);

    if (data) {
      if (!isActive) {
        const params = new URLSearchParams(searchParams);
        params.delete("convId");
        params.delete("widget");
        params.delete("intent");
        params.delete("voiceOnly");
        params.delete("dateRange");
      } else {
        setSearchParams({
          convId: data,
          widget: selectionAssistant ? JSON.stringify(selectionAssistant) : "",
          intent: selectionIntent ? JSON.stringify(selectionIntent) : "",
          voiceOnly: audioChecked,
          dateRange: encodeURIComponent([
            dateRange.startDate,
            dateRange.endDate,
          ]),
        });
      }
      handleConversationapiCall(data, chatData);
    }
  };

  const handleConversationapiCall = async (data, chatData) => {
    setSelectedChat(data);
    setSearchParams({
      convId: data,
      widget: selectionAssistant ? JSON.stringify(selectionAssistant) : "",
      intent: selectionIntent ? JSON.stringify(selectionIntent) : "",
      voiceOnly: audioChecked,
      dateRange: encodeURIComponent([dateRange.startDate, dateRange.endDate]),
    });
    setConversationChatData(chatData);
    setChatLoading(false);
    const getConversation = await fetchController(
      baseUrl +
        `/api/v1/conversation/conversationchat_daterange?conversation_id=${data}&date_from=${dateFormat(
          dateRange.startDate
        )}&date_to=${dateFormat(dateRange.endDate)}`,
      "GET"
    );

    if (getConversation.data) {
      setChatLoading(true);
      setMessages(getConversation.data);
    } else {
      setChatLoading(true);
    }
  };

  const handleAssistantList = async () => {
    const getData = await fetchController(urlHitAssistant, "GET");
    setassistantOption(
      getData?.data?.items?.map((data) => {
        return {
          label: data.name,
          value: data.id,
        };
      })
    );
  };
  const handleIntentList = async () => {
    const getData = await fetchController(urlHitIntent, "GET");
    setintentOption(
      getData?.data?.items?.map((data) => {
        return {
          label: data.name,
          value: data.id,
        };
      })
    );
    if (screenType === "intent") {
      setselectionIntent({
        label: getData?.data?.items[0].name,
        value: getData?.data?.items[0].id,
      });
    }
  };

  const handleAssistantSelect = (value) => {
    setconverSationdata([]);
    setMessages([]);
    sethasMore(true);
    setPage(1);
    setselectionAssistant(value);
    setSearchParams({
      widget: JSON.stringify(value),
      intent: selectionIntent ? JSON.stringify(selectionIntent) : "",
      voiceOnly: audioChecked,
      dateRange: encodeURIComponent([dateRange.startDate, dateRange.endDate]),
    });
  };
  const handleIntentSelect = (value) => {
    setconverSationdata([]);
    setMessages([]);
    sethasMore(true);
    setPage(1);
    setselectionIntent(value);
    setSearchParams({
      widget: selectionAssistant ? JSON.stringify(selectionAssistant) : "",
      intent: JSON.stringify(value),
      voiceOnly: audioChecked,
      dateRange: encodeURIComponent([dateRange.startDate, dateRange.endDate]),
    });
  };

  const handleCheckboxSelect = (value) => {
    setconverSationdata([]);
    setMessages([]);
    sethasMore(true);
    setPage(1);

    setaudioChecked(value.target.checked);
    setSearchParams({
      widget: selectionAssistant ? JSON.stringify(selectionAssistant) : "",
      intent: selectionIntent ? JSON.stringify(selectionIntent) : "",
      voiceOnly: value.target.checked,
      dateRange: encodeURIComponent([dateRange.startDate, dateRange.endDate]),
    });
  };

  useEffect(() => {
    if (!converSationdata) {
      setconversationLoading(false);
    }
    handleConversationCall();
  }, [dateRange, selectionAssistant, selectionIntent, audioChecked]);

  const onIntersection = (entries) => {
    const firstEntry = entries[0];
    if (firstEntry.isIntersecting && hasMore) {
      handleConversationCall();
    }
  };
  useEffect(() => {
    const observer = new IntersectionObserver(onIntersection);
    if (observer && elementRef.current) {
      observer.observe(elementRef.current);
    }
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [converSationdata]);

  const handleConversationCall = async () => {
    try {
      let fullUrl;
      fullUrl = `/api/v1/conversation/conversation_assistant_daterange?${
        selectionAssistant?.value
          ? "assistant_id=" + selectionAssistant?.value + "&"
          : ""
      }${
        selectionIntent?.value
          ? "intent_id=" + selectionIntent?.value + "&"
          : ""
      }date_from=${dateFormat(dateRange.startDate)}&date_to=${dateFormat(
        dateRange.endDate
      )}&includes_voice=${audioChecked}&page=${page}&size=50`;
      const getData = await fetchController(baseUrl + `${fullUrl}`, "GET");
      if (getData) {
        setconversationLoading(true);
        setChatLoading(true);
      }
      if (getData?.data?.items?.length === 0) {
        sethasMore(false);
      }
      let chatId = searchParams?.get("convId");

      if (chatId && getData.data.items.length) {
        const chatIndex = getData.data.items.findIndex(
          (item) => item.id === chatId
        );
        handleConversation(chatId, getData.data.items[chatIndex]);
      } else if (!chatId && getData.data.items.length && page === 1) {
        handleConversation(getData.data.items[0].id, getData.data.items[0]);
      }
      setconverSationdata((prevProduct) => [
        ...prevProduct,
        ...getData?.data.items,
      ]);
      setPage((prevPage) => prevPage + 1);
    } catch (error) {
      setconversationLoading(true);
      setChatLoading(true);
    }
  };

  const {
    isOpen: isConfirmationModalOpen,
    onOpen: onOpenConfirmationModal,
    onClose: onCloseConfirmationModal,
  } = useDisclosure();

  const {
    isOpen: isCheckedConfirmationModalOpen,
    onOpen: onOpenCheckedConfirmationModal,
    onClose: onCloseCheckedConfirmationModal,
  } = useDisclosure();

  const refreshConversation = () => {
    setconverSationdata([]);
    setMessages([]);
    setPage(1);
    setselectionAssistant("");
    setselectionIntent("");
    setDateRange({
      startDate: moment().subtract(7, "d").toDate(),
      endDate: moment().toDate(),
    });
    setaudioChecked(false);
  };

  const onConfirmDelete = async () => {
    if (!deleteChatId) return;
    setDeleteLoader(true);
    try {
      onCloseConfirmationModal();
      const url = baseUrl + `/api/v1/conversation/${deleteChatId}`;
      const response = await fetchController(url, "DELETE");
      setDeleteChatId(null);
      setDeleteLoader(false);
      toast.success(response.detail || "conversation deleted successfully");
      refreshConversation();
    } catch (error) {
      onCloseConfirmationModal();
      setDeleteChatId(null);
      setDeleteLoader(false);
      toast.error(
        "Conversation has other linked items. Please delete them first and then retry."
      );
    } finally {
      setDeleteChatId(null);
      setDeleteLoader(false);
      onCloseConfirmationModal();
    }
  };

  const onCheckedConfirmDelete = async () => {
    setDeleteCheckedConversationLoader(true);
    onCloseCheckedConfirmationModal();
    try {
      const url = baseUrl + `/api/v1/conversation/`;
      const body = [...deleteCheckedItems];
      const response = await fetchController(url, "DELETE", body);
      setDeleteAllChecked(false);
      setDeleteCheckedItems([]);
      setDeleteCheckedConversationLoader(false);
      toast.success(response.detail || "conversations deleted successfully");
      refreshConversation();
    } catch (error) {
      toast.error(
        "Conversation has other linked items. Please delete them first and then retry."
      );
    } finally {
      setDeleteCheckedConversationLoader(false);
    }
  };
  const downloadCSV = async () => {
    if (!selectionAssistant || selectionAssistant === null) {
      toast.error("Select Assistant");
      return;
    }
    axios
      .get(
        baseUrl +
          `/api/v1/conversation/export/csv?assistant_id=${
            selectionAssistant.value
          }&date_from=${dateFormat(dateRange.startDate)}&date_to=${dateFormat(
            dateRange.endDate
          )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "text/csv;charset=utf-8;",
          },
        }
      )
      .then((response) => {
        exportData(response.data, "data.csv", "text/csv;charset=utf-8;");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    handleAssistantList();
    handleIntentList();
  }, []);

  // Polling: silently refresh the conversation list and open messages every 20s
  useEffect(() => {
    const pollRefresh = async () => {
      if (document.visibilityState === "hidden") return;
      try {
        const fullUrl =
          `/api/v1/conversation/conversation_assistant_daterange?${
            selectionAssistant?.value ? "assistant_id=" + selectionAssistant.value + "&" : ""
          }${
            selectionIntent?.value ? "intent_id=" + selectionIntent.value + "&" : ""
          }date_from=${dateFormat(dateRange.startDate)}&date_to=${dateFormat(dateRange.endDate)}&includes_voice=${audioChecked}&page=1&size=50`;
        const getData = await fetchController(baseUrl + fullUrl, "GET");
        if (getData?.data?.items) {
          // Replace only the first page so we don't duplicate paginated items
          setconverSationdata((prev) => {
            const updated = [...getData.data.items];
            // Keep any items beyond page 1 that were already loaded
            prev.slice(getData.data.items.length).forEach((item) => updated.push(item));
            return updated;
          });
          // Update the open conversation's metadata if it's in the refreshed page
          if (selectedChat) {
            const found = getData.data.items.find((item) => item.id === selectedChat);
            if (found) setConversationChatData(found);
          }
        }
      } catch {
        // silent — don't disrupt the user on poll failure
      }

      // Also refresh messages for the open conversation
      if (selectedChat) {
        try {
          const getConversation = await fetchController(
            baseUrl +
              `/api/v1/conversation/conversationchat_daterange?conversation_id=${selectedChat}&date_from=${dateFormat(dateRange.startDate)}&date_to=${dateFormat(dateRange.endDate)}`,
            "GET"
          );
          if (getConversation?.data) setMessages(getConversation.data);
        } catch {
          // silent
        }
      }
    };

    const id = setInterval(pollRefresh, 20000);
    document.addEventListener("visibilitychange", pollRefresh);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", pollRefresh);
    };
  }, [baseUrl, selectionAssistant, selectionIntent, dateRange, audioChecked, selectedChat]);
  const agency = useContext(AgencyContext);
  const { textColor, colorPreset, buttonColorScheme } = agency;
  const chatBg = useColorModeValue("#E8E8E8", theme.colors.gray[700]);
  const chatColor = useColorModeValue("black", "white");
  const selectedChatBg = useColorModeValue(colorPreset || "#3182ce", textColor);
  const moreInfoBg = useColorModeValue("#fff", theme.colors.gray[700]);
  const name = agency?.myDetails?.agency_id
    ? agency?.myDetails?.branding?.agency_name
    : "Insighto.AI";
  const logo = agency?.faviconUrl || "/logo/favicon.png";

  return (
    <VStack h="100%" spacing={2} borderRadius="md">
      <ConfirmationModal
        table={"conversation"}
        isOpen={isConfirmationModalOpen}
        onConfirm={onConfirmDelete}
        onClose={onCloseConfirmationModal}
      />
      <ConfirmationModal
        table={"checkedConversationDelete"}
        isOpen={isCheckedConfirmationModalOpen}
        onConfirm={onCheckedConfirmDelete}
        onClose={onCloseCheckedConfirmationModal}
      />

      <Flex direction={"column"} gap={3} h={"100%"} w={"100%"}>
        <Flex gap={2} w={"100%"} alignItems="center" p={2}>
          <Heading color={textColor} fontSize="xl">
            Conversations
          </Heading>
        </Flex>

        <Card variant={"elevated"} p={3} w={"100%"}>
          <Grid templateColumns="repeat(7, 1fr)" gap={5}>
            <GridItem colSpan={1}>
              <Box
                display={"flex"}
                alignItems={"center"}
                padding={"5px"}
                justifyContent={"flex-start"}
              >
                <CheckboxGroup>
                  <Stack spacing={[1, 5]} direction={["column", "row"]}>
                    <Checkbox
                      isChecked={audioChecked}
                      onChange={handleCheckboxSelect}
                    >
                      Voice Only{audioChecked}
                    </Checkbox>
                  </Stack>
                </CheckboxGroup>
              </Box>
            </GridItem>
            <GridItem colSpan={2}>
              <CustomDateRangePicker
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                onChange={handleDateChange}
              />
            </GridItem>
            <GridItem colSpan={2}>
              <CustomSelect
                placeholder="Filter by Assistant"
                value={selectionAssistant?.value}
                onChange={(val) => {
                  handleAssistantSelect({
                    value: val?.value ? val?.value : null,
                    label: val?.label ? val?.label : null,
                  });
                }}
                options={assistantOption?.map((val) => {
                  return { value: val.value, label: val.label };
                })}
              />
            </GridItem>
            <GridItem colSpan={2}>
              <CustomSelect
                placeholder="Filter by Intent"
                value={selectionIntent?.value}
                onChange={(val) => {
                  handleIntentSelect({
                    value: val?.value ? val?.value : null,
                    label: val?.label ? val?.label : null,
                  });
                }}
                options={intentOption?.map((val) => {
                  return { value: val.value, label: val.label };
                })}
              />
            </GridItem>
          </Grid>
        </Card>

        <Card
          variant={"elevated"}
          h={"100%"}
          paddingBlock={3}
          overflowY={"auto"}
        >
          <Stack spacing={1} h={"100%"} w={"100%"} overflowY={"auto"}>
            {converSationdata.length !== 0 && (
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                boxShadow={"sm"}
                pb={2}
              >
                <Flex
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  pl={3}
                  pr={3}
                >
                  <Box
                    display={"flex"}
                    alignItems={"Center"}
                    padding={"5px"}
                    justifyContent={"center"}
                  >
                    <CheckboxGroup>
                      <Stack spacing={[1, 5]} direction={["column", "row"]}>
                        <Checkbox
                          isChecked={deleteAllChecked}
                          isIndeterminate={isDeleteIndeterminate}
                          onChange={() => {
                            if (deleteAllChecked) {
                              setDeleteAllChecked(false);
                              setDeleteCheckedItems([]);
                            } else {
                              setDeleteCheckedItems(() =>
                                converSationdata.map((messages) => messages.id)
                              );
                            }
                          }}
                          fontWeight={600}
                        >
                          {"Select All"}
                        </Checkbox>
                      </Stack>
                    </CheckboxGroup>
                  </Box>
                  <Box p={2}>
                    {deleteCheckedConversationLoader ? (
                      <Spinner size="md" />
                    ) : (
                      <Box as="span" title="Delete conversations">
                        <MdDelete
                          color={
                            deleteCheckedItems.length ? "red" : "lightgray"
                          }
                          cursor={
                            deleteCheckedItems.length
                              ? "pointer"
                              : "not-allowed"
                          }
                          size={"1.2rem"}
                          onClick={() => {
                            onOpenCheckedConfirmationModal();
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                  <Button
                    type="button"
                    colorScheme={buttonColorScheme}
                    onClick={downloadCSV}
                  >
                    <FaFileDownload />
                  </Button>
                </Flex>
              </Box>
            )}

            <Box
              display={"flex"}
              justifyContent="center"
              gap={2}
              h={"100%"}
              overflowY={"auto"}
            >
              <Card
                d="flex"
                w="30%"
                justifyContent="space-between"
                alignItems="center"
                height="100%"
                overflowY="auto"
                pl={3}
                pr={3}
                variant={"elevated"}
              >
                <Stack
                  spacing="1"
                  h={"100%"}
                  w={"100%"}
                  overflowY={"auto"}
                  sx={{
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                  }}
                >
                  {conversationLoading ? (
                    <>
                      {converSationdata?.length ? (
                        <>
                          {converSationdata?.map((message) => {
                            let attriButes = JSON.parse(message?.attributes);
                            return (
                              <Flex key={message?.id}>
                                <Box
                                  display={"flex"}
                                  alignItems={"Center"}
                                  padding={"5px"}
                                  justifyContent={"center"}
                                >
                                  <CheckboxGroup>
                                    <Stack
                                      spacing={[1, 5]}
                                      direction={["column", "row"]}
                                    >
                                      <Checkbox
                                        isChecked={deleteCheckedItems.includes(
                                          message.id
                                        )}
                                        onChange={() => {
                                          if (
                                            deleteCheckedItems.includes(
                                              message.id
                                            )
                                          ) {
                                            setDeleteCheckedItems((prevState) =>
                                              prevState.filter(
                                                (item) => item !== message.id
                                              )
                                            );
                                          } else {
                                            setDeleteCheckedItems(
                                              (prevState) => [
                                                ...prevState,
                                                message.id,
                                              ]
                                            );
                                          }
                                        }}
                                      ></Checkbox>
                                    </Stack>
                                  </CheckboxGroup>
                                </Box>

                                <Box
                                  bg={
                                    selectedChat === message?.id
                                      ? selectedChatBg
                                      : chatBg
                                  }
                                  color={
                                    selectedChat === message?.id
                                      ? "white"
                                      : chatColor
                                  }
                                  px={3}
                                  py={2}
                                  padding
                                  borderRadius="5px"
                                  key={message.id}
                                  flex={1}
                                  cursor="pointer"
                                  onClick={() => {
                                    handleConversation(message.id, message);
                                  }}
                                >
                                  <Box>
                                    <Box
                                      display={"Flex"}
                                      justifyContent={"space-between"}
                                    >
                                      {" "}
                                      <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                        gap={1}
                                      >
                                        <PiRobotLight width={20} height={20} />
                                        <Text fontSize="xs">
                                          {message?.assistant_name}
                                        </Text>
                                        {attriButes?.ai_paused && (
                                          <Tooltip label="AI Paused">
                                            <span>
                                              <MdOutlinePauseCircle color="orange" size="0.9rem" />
                                            </span>
                                          </Tooltip>
                                        )}
                                      </Box>
                                      <Text fontSize="xs" marginTop={"unset"}>
                                        {moment
                                          .utc(message?.updated_at)
                                          .fromNow()}
                                      </Text>
                                    </Box>
                                    <Box
                                      display={"Flex"}
                                      justifyContent={"space-between"}
                                      mt={"2px"}
                                      mb={"2px"}
                                    >
                                      <Text
                                        fontSize="xs"
                                        display={"flex"}
                                        justifyContent={"center"}
                                        alignItems={"center"}
                                      >
                                        {message?.first_message}
                                      </Text>
                                      <Box>
                                        {message?.intent_name && (
                                          <Tag>{message?.intent_name}</Tag>
                                        )}
                                      </Box>
                                    </Box>
                                  </Box>

                                  <Box
                                    display={"Flex"}
                                    justifyContent={"space-between"}
                                  >
                                    <Box
                                      display={"flex"}
                                      alignItems={"center"}
                                      gap={1}
                                    >
                                      {message.contact_first_name ||
                                      message.contact_last_name ? (
                                        <LuContact />
                                      ) : null}
                                      <Tooltip
                                        label={
                                          attriButes?.call_direction ===
                                          "inbound"
                                            ? attriButes?.from
                                            : attriButes?.to
                                        }
                                      >
                                        <Text
                                          fontWeight={"bold"}
                                          as="i"
                                          fontSize={"10px"}
                                        >
                                          {`${
                                            message?.contact_first_name || ""
                                          } ${
                                            message?.contact_last_name || ""
                                          }`}
                                        </Text>
                                      </Tooltip>
                                    </Box>
                                    <Box
                                      display={"flex"}
                                      alignItems={"center"}
                                      gap={1}
                                    >
                                      {message?.widget_provider ===
                                      "insighto" ? (
                                        <Tooltip label={name}>
                                          <img
                                            src={logo}
                                            width={15}
                                            alt="logo"
                                          />
                                        </Tooltip>
                                      ) : (
                                        <Tooltip
                                          label={
                                            providers[message?.widget_provider]
                                              .label
                                          }
                                        >
                                          <img
                                            src={
                                              providers[
                                                message?.widget_provider
                                              ].logo
                                            }
                                            width={15}
                                            alt="widget_logo"
                                          />
                                        </Tooltip>
                                      )}
                                      <Flex justifyContent="end" p={"0.3rem"}>
                                        <>
                                          {deleteChatId === message.id &&
                                          deleteLoader ? (
                                            <Spinner size="sm" />
                                          ) : (
                                            <Box
                                              as="span"
                                              title="Delete conversation"
                                            >
                                              <MdDelete
                                                color={
                                                  deleteCheckedItems.includes(
                                                    message.id
                                                  ) ||
                                                  deleteCheckedConversationLoader
                                                    ? "lightgray"
                                                    : "red"
                                                }
                                                cursor={
                                                  deleteCheckedItems.includes(
                                                    message.id
                                                  ) ||
                                                  deleteCheckedConversationLoader
                                                    ? "not-allowed"
                                                    : "pointer"
                                                }
                                                size={"1rem"}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  if (
                                                    deleteCheckedItems.includes(
                                                      message.id
                                                    ) ||
                                                    deleteCheckedConversationLoader
                                                  )
                                                    return;
                                                  setDeleteChatId(message.id);
                                                  onOpenConfirmationModal();
                                                }}
                                              />
                                            </Box>
                                          )}
                                        </>
                                      </Flex>
                                      {message?.includes_voice ? (
                                        <FaMicrophone />
                                      ) : (
                                        ""
                                      )}
                                      {message.device_type === "phone" &&
                                      attriButes.call_direction ===
                                        "inbound" ? (
                                        <SlCallIn
                                          title={
                                            `From: ${attriButes?.from_formatted}` ||
                                            "Phone number N/A"
                                          }
                                        />
                                      ) : message.device_type === "phone" &&
                                        attriButes.call_direction ===
                                          "outbound" ? (
                                        <SlCallOut
                                          title={
                                            `To: ${attriButes?.to_formatted}` ||
                                            "Phone number N/A"
                                          }
                                        />
                                      ) : null}

                                      {message.device_type === "desktop" ? (
                                        <TbDeviceDesktop />
                                      ) : null}
                                      <Box
                                        display={"flex"}
                                        alignItems={"center"}
                                        gap={1}
                                      >
                                        <FiMessageSquare
                                          width={20}
                                          height={20}
                                        />

                                        <Text fontSize="xs">
                                          {" "}
                                          {message?.chat_count}
                                        </Text>
                                      </Box>
                                    </Box>
                                  </Box>
                                  {hasMore && <Box ref={elementRef}> </Box>}
                                </Box>
                              </Flex>
                            );
                          })}
                        </>
                      ) : (
                        <Box
                          px={3}
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          py={2}
                          padding
                          borderRadius="5px"
                        >
                          No conversation
                        </Box>
                      )}
                    </>
                  ) : (
                    <>
                      {skeletonMap.map((item) => {
                        return (
                          <>
                            <Skeleton
                              startColor="#3182ce6e"
                              endColor="##3182ce6e"
                              height="36px"
                              key={`${item}`}
                            ></Skeleton>
                          </>
                        );
                      })}
                    </>
                  )}
                </Stack>
              </Card>

              <Box
                d="flex"
                flex={1}
                height="100%"
                overflowY="auto"
                overflowX={"hidden"}
                justifyContent="space-between"
                alignItems="center"
                position={"relative"}
              >
                <Box
                  display={"flex"}
                  className="parent"
                  id="parentDiv"
                  overflowY="auto"
                  overflowX={"hidden"}
                  height={"100%"}
                  position={"relative"}
                  w={"100%"}
                >
                  <>
                    {chatLoading ? (
                      <>
                        {messages.length && !chatClose ? (
                          <>
                            <Box width={"70%"} display="flex" flexDirection="column">
                              <Box flex={1} overflowY="auto">
                                {messages?.map((messageData) => (
                                  <Message
                                    messageData={messageData?.ConversationChat}
                                    key={messageData.id}
                                  />
                                ))}
                              </Box>
                              {aiPaused && !isClosed && (
                                <Flex gap={2} p={2} borderTop="1px solid" borderColor="gray.200">
                                  <Input
                                    placeholder="Type a message as agent..."
                                    value={agentMessage}
                                    onChange={(e) => setAgentMessage(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendAgentMessage(); } }}
                                    size="sm"
                                  />
                                  <Button
                                    size="sm"
                                    colorScheme={buttonColorScheme}
                                    isLoading={sendingMessage}
                                    onClick={sendAgentMessage}
                                    leftIcon={<FiSend />}
                                  >
                                    Send
                                  </Button>
                                </Flex>
                              )}
                            </Box>
                            <Box d="flex" w="30%">
                              <Box width={"100%"}>
                                <Box
                                  pl={3}
                                  pr={3}
                                  d="flex"
                                  w="100%"
                                  height="100%"
                                  overflowY="auto"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    className="parent"
                                    id="parentDiv"
                                    opacity={isClosed ? 0.5 : 1}
                                    pointerEvents={isClosed ? "none" : "auto"}
                                    position="relative"
                                  >
                                    {isClosed && (
                                      <Box
                                        position="absolute"
                                        top={0}
                                        left={0}
                                        right={0}
                                        textAlign="center"
                                        py={1}
                                        bg="gray.100"
                                        borderRadius="md"
                                        fontSize="xs"
                                        color="gray.500"
                                        fontWeight="semibold"
                                        zIndex={1}
                                      >
                                        Conversation Closed
                                      </Box>
                                    )}
                                    <Flex
                                      direction="column"
                                      gap={2}
                                      p={2}
                                      mt={isClosed ? 6 : 0}
                                    >
                                      {/* Tool Function Logs — always visible */}
                                      <Button
                                        colorScheme="gray"
                                        size="sm"
                                        w="100%"
                                        pointerEvents="auto"
                                        opacity={1}
                                        leftIcon={<LuSquareFunction />}
                                        onClick={() => {
                                          onToolFunctionLogOpen();
                                          setChatClose(true);
                                        }}
                                      >
                                        Tool Function Logs
                                      </Button>
                                      {/* Action buttons — hidden when closed */}
                                      {!isClosed && (
                                        <>
                                          <Button
                                            colorScheme={aiPaused ? "green" : "orange"}
                                            size="sm"
                                            w="100%"
                                            leftIcon={aiPaused ? <MdOutlinePlayCircle /> : <MdOutlinePauseCircle />}
                                            onClick={toggleAiPause}
                                          >
                                            {aiPaused ? "Release Control" : "Take Control"}
                                          </Button>
                                          <Button
                                            colorScheme="red"
                                            variant="outline"
                                            size="sm"
                                            w="100%"
                                            leftIcon={<MdOutlineCancel />}
                                            onClick={closeConversation}
                                          >
                                            Close Conversation
                                          </Button>
                                        </>
                                      )}
                                    </Flex>
                                    <Summary
                                      conversationChatData={
                                        conversationChatData
                                      }
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </>
                        ) : (
                          <Box
                            px={3}
                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            py={2}
                            padding
                            borderRadius="5px"
                          >
                            No chat{" "}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Box
                        display={"flex"}
                        flexDirection={"column"}
                        spacing={"2"}
                      >
                        <Stack spacing="1">
                          {skeletonMap.map((item) => {
                            return (
                              <>
                                <Skeleton
                                  startColor="#3182ce6e"
                                  endColor="##3182ce6e"
                                  height="36px"
                                  bg="green.500"
                                  color="white"
                                  key={`${item}`}
                                ></Skeleton>
                              </>
                            );
                          })}
                        </Stack>
                      </Box>
                    )}

                    {isToolFunctionLogOpen && (
                      <Box
                        shadow={"md"}
                        bgColor={moreInfoBg}
                        width={"100%"}
                        className={`conversation-drawer ${
                          isToolFunctionLogOpen ? "slide-out" : "slide-in"
                        }`}
                      >
                        <Flex justifyContent={"flex-end"}>
                          <CloseButton
                            onClick={() => {
                              onToolFunctionLogClose();
                              setChatClose();
                            }}
                          />
                        </Flex>
                        <Box
                          pl={3}
                          pr={3}
                          d="flex"
                          w="100%"
                          height="65vh"
                          overflowY="auto"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box className="parent" id="parentDiv">
                            <ConversationLogsPage
                              conversationId={selectedChat}
                              skeletonMap={skeletonMap}
                            />
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Card>
      </Flex>
    </VStack>
  );
};
export default ConversationsUtility;
